import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

/** Which real-time game the live match belongs to. */
export type ActiveMatchGame = 'qgammon' | 'qcp';

/** The one live match whose socket the app keeps connected across navigation. */
export interface ActiveMatchDescriptor {
  game: ActiveMatchGame;
  matchId: string;
  /** QGammon board orientation ('W'|'B'); undefined for QCP. */
  perspective?: 'W' | 'B';
  /** QCP practice flag; undefined/false otherwise. */
  vsBot?: boolean;
  /** Epoch ms at start — for ordering/debug only (forfeit is server-side). */
  startedAt: number;
}

interface ActiveMatchState {
  current: ActiveMatchDescriptor | null;
}

const initialState: ActiveMatchState = { current: null };

const activeMatchSlice = createSlice({
  name: 'activeMatch',
  initialState,
  reducers: {
    setActiveMatch(state, action: PayloadAction<ActiveMatchDescriptor>) {
      state.current = action.payload;
    },
    clearActiveMatch(state) {
      state.current = null;
    },
  },
});

export const { setActiveMatch, clearActiveMatch } = activeMatchSlice.actions;
export default activeMatchSlice.reducer;
